import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const TableItem = ({ title, subTitle }) => {

  if (_.isEmpty(subTitle)) {
    return <>{ title }</>;
  }
  return (
    <>
      <p>{ title }</p>
      <small>{ subTitle }</small>
    </>
  );
};

TableItem.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default TableItem;
